import { SecretsManagerClient, GetSecretValueCommand } from "@aws-sdk/client-secrets-manager";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

let client: SecretsManagerClient | null = null;

export const SecretsService = {
    initialize(region: string, identityPoolId: string, idToken: string, userPoolId: string) {
        const loginKey = `cognito-idp.${region}.amazonaws.com/${userPoolId}`;
        client = new SecretsManagerClient({
            region,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region },
                identityPoolId,
                logins: { [loginKey]: idToken },
            }),
        });
    },

    async getSecrets(secretArn: string): Promise<Record<string, unknown>> {
        if (!client) throw new Error("SecretsService not initialized");
        const cmd = new GetSecretValueCommand({ SecretId: secretArn });
        const res = await client.send(cmd);
        return JSON.parse(res.SecretString || "{}");
    },
};
